import { Component, Input, OnInit } from '@angular/core';
import { ExportFileService } from 'src/app/gamification/command-center/services/export-file.service';
import { ExportItems, TypeFormats } from 'src/shared/types/exportItem';
import { CVLocalizationService } from '../../../../../../reusables/services/cv-localization.service';

@Component({
  selector: 'cv-currency-pending-export-button',
  templateUrl: './currency-pending-export-button.component.html',
  styleUrls: ['./currency-pending-export-button.component.scss']
})
export class CurrencyPendingExportButtonComponent implements OnInit {

  @Input()
  filterText: string;
  @Input()
  filterRule: string;
  @Input()
  sortValue: string;
  @Input()
  data: any;
  @Input()
  columns: { field: string, headerName: string }[];

  public localizationDic: Map<string, string> = new Map();

  items: ExportItems = {
    excel: {
      getData: (format) => this.exportCurrencyPendingReport(format),
    },
    csv: {
      getData: (format) => this.exportCurrencyPendingReport(format),
    }
  };

  constructor(private exportFile: ExportFileService, private locService: CVLocalizationService) { }

  ngOnInit(): void {    
    this.initAsync();
  }

  async initAsync() {
    this.localizationDic = await this.locService.GetSection("Gamification_Admin");
    this.loadLocalizations();
  }

  async exportCurrencyPendingReport(format: TypeFormats) {
    const body = {
      format,
      data: this.data || [],
      selectedColums: this.columns || [{
        field: "ActionDate_ForView",
        headerName: this.getLocalizationString("Event_Date_Column", "Event Date")
      }, {
        field: "Login.LoginName",
        headerName: this.getLocalizationString("Logins_Column", "Logins")
      }, {
        field: "Description",
        headerName: this.getLocalizationString("Description_Column", "Description")
      }, {
        field: "CurrencyAmount",
        headerName: this.getLocalizationString("Amount_Column", "Amount")
      }],
        selectedFilters: [{
        filter: "Rules",
        value: this.filterRule 
        }, {
        filter: this.getLocalizationString("Search_Text", "Search text"), 
        value: this.filterText || this.getLocalizationString("None", "None") 
      }],
      filtertext: this.filterText || "",
      filterrule: this.filterRule || "-1",
      sortvalue: this.sortValue || ""
    }

    return this.exportFile.exportReport("/api/v1/gamification/currency-pending/export", body);
  };

  loadLocalizations() {
    this.locService.GetSection("Gamification_Admin").then((map) => {
      this.localizationDic = map;
    });
  }

  getLocalizationString(key, defaultValue) {
    if (this.localizationDic && this.localizationDic.has(key))
      return this.localizationDic.get(key);
    return defaultValue;
  }
}
